import React, { Fragment } from "react";
import PropTypes from "prop-types";

const QPI = ({score}) => {
  return (
      <div className = "qpi-container">
        <h2>QPI</h2>
        <p className = "qpi-text">{score}</p>
      </div>
  );
};

QPI.propTypes = {
  score: PropTypes.string.isRequired,
};

export default QPI;
